import "react-app-polyfill/ie11"; // This *must* go first, according to docs:
import "./polyfill";

import "bootstrap/dist/css/bootstrap.min.css";
import "./global.css";

import * as Sentry from "@sentry/browser";
import * as React from "react";
import * as ReactDOM from "react-dom";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";

if (process.env.REACT_APP_ACP_ENV !== "dev") {
  Sentry.init({
    dsn: "https://c14803968f1040bdab80b7f34db2a80a@sentry.io/2584114",
    environment: process.env.REACT_APP_ACP_ENV
  });
  // Sentry.setExtra("env", process.env.REACT_APP_ACP_ENV);
}

ReactDOM.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
  document.getElementById("root") as HTMLElement
);
